export default "__VITE_ASSET__wU2szdcx__"